export default __webpack_public_path__ + "static/media/047.dc6d1d60.png";